var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './BlockedPage.module.css';
import { useCallback } from 'react';
import { storage } from '../../../Services/storage';
import { PageLayout } from '../../Components/PageLayout';
export var BlockedPage = function () {
    var reloadApp = useCallback(function () {
        storage.clearAll();
        window.location.reload();
    }, []);
    return (_jsxs(PageLayout, __assign({ footer: { actionButtonLabel: 'Got it', buttonClick: reloadApp } }, { children: [_jsx("h2", __assign({ className: styles.title }, { children: "Transactions are limited" })), _jsx("p", __assign({ className: styles.text }, { children: "Unfortunately, we cannot process your transaction in accordance with the internal policy of the company." }))] })));
};
